
























































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getChannelGroupInfo } from "@/services/channels/channelGroupService";
import { ChannelGroupInfo } from "@/services/channels/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

@Component
export default class ChannelGroupInfoModal extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    channelGroupInfo = {} as ChannelGroupInfo;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;

    open(channelGroupId: string) {
        getChannelGroupInfo(channelGroupId).then(response => {
            this.channelGroupInfo = response;
            this.$bvModal.show("modal-channelGroupInfo");
        });
    }

    hide() {
        this.$bvModal.hide("modal-channelGroupInfo");
    }

    goToBackground(id: string) {
        return {
            name: "updatebackground",
            params: { backgroundId: id }
        };
    }

    goToTemplate(id: string) {
        return {
            name: "updatetemplate",
            params: { templateId: id }
        };
    }

    goToSolution(id: string) {
        return {
            name: "updateSolution",
            params: { solutionId: id }
        };
    }

    goToStage(id: string) {
        return {
            name: "updateStage",
            params: {
                stageId: id
            }
        };
    }
}
